import { render, staticRenderFns } from "./suspendedDialog.vue?vue&type=template&id=1e3ddebe"
import script from "./suspendedDialog.vue?vue&type=script&lang=js"
export * from "./suspendedDialog.vue?vue&type=script&lang=js"
import style0 from "./suspendedDialog.vue?vue&type=style&index=0&id=1e3ddebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports